import { createContext, useContext, useState, useEffect } from "react";
import { getStoreSettings } from "../api/store";

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
    const [currencySymbol, setCurrencySymbol] = useState("$");
    const [currencyCode, setCurrencyCode] = useState("USD");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getStoreSettings()
            .then((settings) => {
                setCurrencySymbol(settings.currency_symbol || "$");
                setCurrencyCode(settings.currency || "USD");
            })
            .catch(() => {
                // Fallback to USD if API fails
                setCurrencySymbol("$");
                setCurrencyCode("USD");
            })
            .finally(() => setLoading(false));
    }, []);

    const formatPrice = (price) => {
        const num = parseFloat(price || 0);
        return `${currencySymbol}${num.toFixed(2)}`;
    };

    return (
        <CurrencyContext.Provider
            value={{ currencySymbol, currencyCode, formatPrice, loading }}
        >
            {children}
        </CurrencyContext.Provider>
    );
}

export function useCurrency() {
    const context = useContext(CurrencyContext);
    if (!context)
        throw new Error("useCurrency must be used within CurrencyProvider");
    return context;
}
